module.exports = __webpack_public_path__ + "static/img/公司地址.f7df4702.png";